import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const About = () => {
  const values = [
    { title: "Clarity", text: "We simplify complexity so leaders can make fast, confident decisions." },
    { title: "Accountability", text: "Every recommendation is tied to measurable business outcomes." },
    { title: "Precision", text: "Our data, targeting, and operations are built for reliability, not guesswork." },
    { title: "Partnership", text: "We work as an extension of your team, not a disconnected vendor." },
  ];

  const ecosystem = [
    "CRM and Marketing automation teams",
    "B2B data and Intent providers",
    "Revenue operations consultants",
    "Campaign and Analytics specialists",
  ];

  return (
    <main>
      <Helmet>
        <title>About Us | ThinkRise USA</title>
        <meta
          name="description"
          content="Learn how ThinkRise USA helps U.S. B2B teams align strategy and execution with data, campaigns, and RevOps systems that drive revenue."
        />
      </Helmet>
      <section className="page-hero about-hero">
        <div className="container">
          <h1 className="page-hero-title">About ThinkRise USA</h1>
          <p className="page-hero-subtitle">
            We help growth leaders build repeatable pipeline systems using strategy, technology, and data built for the U.S. market.
          </p>
          <Link to="/contact" className="btn">Speak With Our Team</Link>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">Our Mission</h2>
            <div className="content-text">
              <p>
                ThinkRise USA was founded to close the gap between growth strategy and day-to-day execution.
                Too many teams invest in tools but still struggle to generate consistent, high-quality opportunities.
              </p>
              <p>
                We build practical systems that align sales and marketing around shared revenue goals.
                The result is clearer pipeline visibility and stronger conversion performance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section about-values-section">
        <div className="container">
          <h2 className="section-title">What We Stand For</h2>
          <div className="about-values-grid">
            {values.map((item) => (
              <article key={item.title} className="about-value-card">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section about-ecosystem-section">
        <div className="container">
          <h2 className="section-title">Our Delivery Ecosystem</h2>
          <div className="about-ecosystem-board">
            {ecosystem.map((item, index) => (
              <div key={item} className="about-ecosystem-item">
                <span>{index + 1}</span>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
